<template>
    <referrals-confirmation :heading="$t('pages.referrals.show.declined.heading', { type: type })" type="error">
        <template #content>
            <common-page-copy :isCenter="true" size="major">
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div v-html="$t('pages.referrals.show.declined.description', { type: type })"></div>
            </common-page-copy>
        </template>

        <template #footer>
            <common-buttons>
                <common-button
                    :route="{ name: 'referrals.received.referrals' }"
                    :label="$t('pages.referrals.show.declined.button')"
                    size="large"
                    type="primary"
                ></common-button>
            </common-buttons>
        </template>
    </referrals-confirmation>
</template>

<script>
    import { composeDisplayName } from 'components/common/CommonUserName'
    import ReferralsConfirmation from 'components/page-elements/ReferralsConfirmation'

    export default {
        components: {
            ReferralsConfirmation,
        },

        props: {
            referral: { type: Object, required: true },
            type: { type: String, required: false, default: 'declined', validator: (v) => ['declined', 'cancelled'].includes(v) },
        },

        computed: {
            patientName() {
                return composeDisplayName(this.referral.patient)
            },
        },
    }
</script>
